import type { WalkthroughConfig } from "../types";

export const programmingWalkthrough: WalkthroughConfig = {
  id: "page-programming",
  title: "Programming Calendar",
  description: "Understand the programming operations layer — calendar, pipeline, and capacity planning.",
  type: "page",
  pageRoute: "/programming-calendar",
  duration: "1 min",
  category: "pages",
  icon: "CalendarDays",
  steps: [
    {
      id: "intro",
      title: "Programming Operations",
      description:
        "The Programming Calendar is your strategic planning layer. It brings together all programming items — events, series, campaigns — into one unified view.",
      placement: "center",
      animation: "fade",
      icon: "CalendarDays",
    },
    {
      id: "calendar",
      title: "Calendar View",
      description:
        "See all your programming on a visual calendar. Identify gaps, avoid conflicts, and plan a balanced programming mix across the year.",
      placement: "center",
      animation: "slide-up",
      icon: "CalendarDays",
    },
    {
      id: "pipeline",
      title: "Pipeline View",
      description:
        "Track programming items through stages — from concept to planning to execution. Drag items between stages as they progress.",
      placement: "center",
      animation: "fade",
      icon: "Kanban",
    },
    {
      id: "capacity",
      title: "Capacity Planning",
      description:
        "Visualize your programming mix by category, format, and outcome type. Ensure you're delivering a balanced mix of value to members.",
      placement: "center",
      animation: "scale",
      icon: "BarChart3",
      nextLabel: "Got it! ✓",
    },
  ],
};
